import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { normalizeActions } from './adapters';
import { ActionChoice, EditStatusField } from './types';
import { CandidateEditStatusProps } from '../types';

const useController = ({ toggleEditStatus }: CandidateEditStatusProps) => {
  const { getValues, handleSubmit } = useFormContext<Record<EditStatusField, string>>();
  const [actions, setActions] = useState<ActionChoice[]>([]);
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const getActions = async () => {
    const response = await runRequest({
      fetchType: 'GET_ONE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Actions,
      },
      mode: 'silent',
    });

    setActions(normalizeActions(response.data.actions));
  };

  useEffect(() => {
    if (!workerId) return;
    getActions();
  }, [workerId]);

  const handleClose = () => toggleEditStatus();

  const handleSave = async () => {
    const action = getValues('action');
    const note = getValues('note');

    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Actions,
        targetId: action,
        data: { note },
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error updating status' },
        onSuccess: { message: 'Status updated successfully' },
      },
    });

    handleClose();
  };

  return {
    actions,
    handleClose,
    handleSave: handleSubmit(handleSave),
  };
};

export default useController;
